<template>
  <div class="tournamentLive">
    <div class="tournamentLive__header" @click="gotoTournament">
      <TournamentCard :tournament="tournament" />
    </div>
    <p class="title is-4 has-text-success my-5">LIVE MATCHES</p>
    <div class="tournament__matches">
      <div
        v-for="match in sortedMatches"
        :key="match.id"
        @click="viewMatch(match.id)"
      >
        <GameView :gameId="match.id" class="mx-4 mb-6" />
      </div>
    </div>
  </div>
</template>

<script>
import TournamentCard from "@/components/tournaments/TournamentCard.vue";
import GameView from "@/components/games/GameView.vue";
import { TournamentsAPI } from "@/services/api";
import { firestore } from "@/services/firebase";
import { mapGetters } from "vuex";
import gameUrls from "@/mixins/gameUrls";

const matches = firestore.collection("matches");

export default {
  name: "TournamentLive",

  components: {
    TournamentCard,
    GameView,
  },

  mixins: [gameUrls],

  data() {
    return {
      tournamentId: null,
      tournament: {},
      matches: [],
    };
  },

  computed: {
    ...mapGetters(["getPlayer"]),

    sortedMatches() {
      if (!this.matches || !this.matches.length) return [];
      return [...this.matches].sort((a, b) =>
        a.board ? a.board - b.board : a.match_id > b.match_id
      );
    },
  },

  watch: {
    tournamentId: {
      immediate: true, // call it upon creation too
      handler(tournamentId) {
        if (!tournamentId) return;
        this.$bind(
          "matches",
          matches
            .where("tournamentId", "==", this.tournamentId)
            .where("status", "==", "live")
        );
        this.getTournament();
      },
    },
  },

  methods: {
    async getTournament() {
      if (isNaN(this.tournamentId)) {
        this.$bind(
          "tournament",
          firestore.collection("tournaments").doc(this.tournamentId)
        );
        return;
      }
      await TournamentsAPI.getTournament(this.tournamentId, false).then(
        (data) => {
          if (data) {
            this.tournament = data;
          }
        }
      );
    },

    viewMatch(matchId) {
      this.$router.push({
        path: this.getTournamentGameUrl(this.tournamentId, matchId),
      });
    },

    gotoTournament() {
      this.$router.push({
        path: `/tournaments/${this.tournamentId}`,
      });
    },
  },

  created() {
    this.tournamentId = this.$route.params.tournamentId;
  },
};
</script>

<style scoped>
.tournamentLive__header {
  cursor: pointer;
}

.tournament__matches {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}
</style>
